import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';
import {
  TablePopUpContainer,
  usePopupStore,
} from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { gameLiveConnection } from '../../module/gameLiveConnection/gameLiveConnection';

export const GeneralPopups = observer(() => {
  const { connectionError, reconnect } = usePopupStore();

  const handleOffline = useCallback(() => {
    popupStore.onConnectionError(true);
  }, []);


  const handleOnline = useCallback(() => {
    popupStore.onConnectionError(false);
    popupStore.toggleReconnect(true);
    gameLiveConnection.socketRecursiveReconnecting();
  }, []);


  useEffect(() => {
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };

  }, [handleOffline, handleOnline]);

  return (reconnect || connectionError) && <TablePopUpContainer popupMap={null} gameIsOpen={false} />;

});